import store from '@/store/index'

export default {}

/**
 * Returns the full state object for the specified module.
 *
 * @param module String
 *
 * @returns Object
 */
export const get = (module) => {
  return store.getters[`${module}/get`]
}

/**
 * Returns an array of photos for the specified module.
 *
 * @param module String
 *
 * @returns Array
 */
export const photos = (module) => {
  return store.getters[`${module}/photos`]
}

/**
 * Returns the number of photos.
 *
 * @param module String
 *
 * @returns Number
 */
export const photosCount = (module) => {
  return store.getters[`${module}/photos`].length
}

/**
 * Finds and returns a photo by id or undefined if not found.
 *
 * @param module String
 * @param id     Number
 *
 * @returns Array
 */
export const photoById = (module, id) => {
  return store.getters[`${module}/photos`].find(
    photo => photo.id === id
  )
}

/**
 * Finds and returns a photo by index or undefined if not found.
 *
 * @param module String
 * @param index  Number
 *
 * @returns Array
 */
export const photoByIndex = (module, index) => {
  let photos = store.getters[`${module}/photos`]
  if (index < photos.length) {
    return photos[index]
  } else {
    return undefined
  }
}

/**
 * Returns the current form warning.
 *
 * @param module String
 *
 * @return string
 */
export const warning = (module) => {
  return store.getters[`${module}/warning`]
}

/**
 * Returns the newest (last) photo in the list of photos.
 *
 * @param module String
 *
 * @returns Object
 */
export const newest = (module) => {
  return photos[store.getters[`${module}/get`].length - 1]
}

/**
 * API request to create a new photo. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const post = (module, payload) => {
  return store.dispatch(`${module}/post`, payload)
}

/**
 * API request to create multiple new photos. The payload must be in the format:
 * { url: String, data: Array }
 *
 * @param module  String
 * @param payload Object
 */
export const postMultiple = (module, payload) => {
  return store.dispatch(`${module}/postMultiple`, payload)
}

/**
 * API request to delete an existing photo. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const deletePhoto = (module, payload) => {
  return store.dispatch(`${module}/delete`, payload)
}

/**
 * Set an array of photos.
 *
 * @param module   String
 * @param photos Array
 */
export const setPhotos = (module, photos) => {
  store.commit(`${module}/setPhotos`, photos)
}

/**
 * Add a new photo.
 *
 * @param module  String
 * @param photo Object
 */
export const add = (module, photo) => {
  store.commit(`${module}/add`, photo)
}

/**
 * Adds multiple new photos.
 *
 * @param module String
 * @param photos Array
 */
export const addMultiple = (module, photos) => {
  store.commit(`${module}/addMultiple`, photos)
}

/**
 * Find a photo by index in the array of photos and updates it.
 *
 * @param module  String
 * @param photo Object
 * @param index   Number
 */
export const updateByIndex = (module, photo, index) => {
  store.commit(`${module}/updateByIndex`, { photo, index })
}

/**
 * Updates the last photo that was added.
 *
 * @param module  String
 * @param photo Object
 */
export const updateNewest = (module, photo) => {
  store.commit(`${module}/updateNewest`, photo)
}

/**
 * Find a photo by id and remove it.
 *
 * @param module  String
 * @param id      Number
 */
export const removeById = (module, id) => {
  store.commit(`${module}/removeById`, id)
}

/**
 * Find a photo by id and remove it.
 *
 * @param module  String
 * @param index   Number
 */
export const removeByIndex = (module, index) => {
  store.commit(`${module}/removeByIndex`, index)
}

/**
 * Clears the photos from the state.
 *
 * @param module String
 */
export const purge = (module) => {
  store.commit(`${module}/purge`)
}

/**
 * Sets the isAdding form state.
 *
 * @param module   String
 * @param isAdding Boolean
 */
export const setIsAdding = (module, isAdding) => {
  store.commit(`${module}/setIsAdding`, isAdding)
}

/**
 * Sets the isDeleting form state.
 *
 * @param module   String
 * @param isDeleting Boolean
 */
export const setIsDeleting = (module, isDeleting) => {
  store.commit(`${module}/setIsDeleting`, isDeleting)
}

/**
 * Sets the form warning.
 *
 * @param module  String
 * @param warning String
 */
export const setWarning = (module, warning) => {
  store.commit(`${module}/setWarning`, warning)
}

/**
 * Resets the form state.
 *
 * @param module   String
 */
export const resetFormState = (module) => {
  store.commit(`${module}/resetFormState`)
}



// WEBPACK FOOTER //
// ./src/store/photos/photos.helpers.js